// extracted by mini-css-extract-plugin
export var cartContainer = "_k3-4";
export var gray = "_k3-1";
export var itemContainer = "_k3-2";
export var itemDetails = "_k3-3";
export var strong = "_k3-0";